/**
 * Responsibility: Implement world log behavior for the ui/helpers surface.
 * Scope: Owns ui/helpers concerns only; cross-surface orchestration is excluded.
 */
import type { WorldEvent } from "@anyquest/shared-core"
const WORLD_LOG_PREVIEW_LIMIT = 10
export function getWorldLogPreview(entries: WorldEvent[] | null | undefined, limit = WORLD_LOG_PREVIEW_LIMIT): WorldEvent[] {
  if (!entries?.length) return []
  return entries.slice(-limit).reverse()
}

export function getWorldLogTypeLabel(entry: WorldEvent | null | undefined): string {
  return String(entry?.type ?? 'world').toUpperCase()
}

export function toWorldLogLine(entry: WorldEvent): string {
  return `[${entry.time}] (${getWorldLogTypeLabel(entry)}) ${entry.text}`
}

export function buildWorldLogModalBody(entries: WorldEvent[] | null | undefined): string {
  if (!entries?.length) return ''
  return entries
    .slice()
    .reverse()
    .map(toWorldLogLine)
    .join('\n\n')
}
